import {useGridList as $34d813d3524a584a$export$664f9155035607eb} from "../gridlist/useGridList.mjs";

/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $5b4f3d75efdf6481$export$fb0040ce9d6e8bd1(props, state, ref) {
    let { gridProps: gridProps } = (0, $34d813d3524a584a$export$664f9155035607eb)(props, state, ref);
    gridProps.role = 'treegrid';
    return {
        gridProps: gridProps
    };
}


export {$5b4f3d75efdf6481$export$fb0040ce9d6e8bd1 as useTree};
//# sourceMappingURL=useTree.mjs.map
